export default {
  translation: {
    OpenApp: "Mở ứng dụng",
    FAQ: "Câu hỏi thường gặp",
    AboutUs: "Về chúng tôi",
    Tutorials: "Hướng dẫn",
    Blog: "Blog",
    MyPlansTitle: "Gói tập luyện của tôi",
    MyPlansDescription:
      "Bạn có thể xem danh sách các gói tập luyện mà tôi có thể thiết kế trong phần này. Lưu ý rằng những gói này chưa được chuẩn bị trước và được thiết kế dựa trên tình trạng thể chất và mục tiêu của bạn. Bạn cũng có thể liên hệ với tôi qua nút chat trong hồ sơ của tôi sau khi cài đặt ứng dụng Rambody.",
    ExpertiseTitle: "Chuyên môn của tôi",
    AboutMeTitle: "Tổng quan về tôi",
    DownloadApps: "Tải ứng dụng",
    DownloadApps_sharelink: "1. Tải ứng dụng",
    DownloadDescription: "",
    TutorialVideo: "Hướng dẫn",
    TutorialVideoDescription:
      "Xem video hướng dẫn tại đây để sử dụng tốt hơn và hiểu biết về cách thiết kế kế hoạch tập luyện.",
    CompanyDescription:
      "Rambody là một nền tảng giao tiếp giữa huấn luyện viên và học viên để cung cấp kế hoạch tập luyện và dinh dưỡng riêng biệt.",
    AllRightsReserved: "Bảo lưu mọi quyền 2019. Farosa Technologies Inc.",
    CompanyName: "Farosa Technologies Inc",
    Level: "Bước",
    HowToApplyProgram: "Làm thế nào để đăng ký gói tập luyện?",
    ApplyProgramLevel1: "Tải ứng dụng Rambody",
    ApplyProgramLevel2: "Tìm kiếm ID của tôi ({0}) trong ứng dụng",
    ApplyProgramLevel3: "Đăng ký một gói dựa trên nhu cầu và mục tiêu của bạn",
    ApplyProgramLevel4: "Thiết kế và gửi đơn đăng ký trong thời gian quy định",
    Close: "Đóng",
    ReadMore: "Xem thêm",
    Less: "Ít hơn",
    experimental: "Thử nghiệm",
    expert: "Chuyên gia",
    amateur: "Nghiệp dư",
    totalSentPlans: "Tổng số kế hoạch đã gửi",
    download: "Tải Rambody",
    requestPackage: "Yêu cầu kế hoạch",
    info1: "2. Đăng ký trong ứng dụng",
    info2: "3. Quay lại trang này",
    info3: "4. Nhấp vào nút bên dưới",
    redirectingToApp: "Đang cố gắng mở ứng dụng Rambody...",
    ifNotRedirected:
      "Chưa có ứng dụng? Chúng tôi sẽ đưa bạn đến tải xuống trong giây lát.",
  },
};
